export default {
  cashAccounts: [],
  cashAccount: {},
  cashAccountId: null,
  cashAccountCode: null,
  cashAccountVoucher: {},

  bankAccounts: [],
  bankAccount: {},
  bankAccountId: null,
  bankAccountCode: null,
  bankAccountVoucher: {},

  chequeStatuses: [],

  chequeBatch: [],
  chequeBatchCode: null,

  chequeBatchDetail: [],

  receiveCashes: [],
  receiveCash: {},
  receiveCashCode: null,
  receiveCashNavigation: {},
  receiveCashCheckDelete: "",
  receiveCashVoucher: [],
  receiveVoucherNumber: null,
  receiveVoucherId: null,

  paymentCashes: [],
  paymentCash: {},
  paymentCashId: null,
  paymentCashCode: null,
  paymentChequeId: null,
  paymentChequeData: [],
  paymentCashNavigation: {},
  paymentCashVoucher: [],
  paymentCashCheckDelete: "",
  paymentVoucherNumber: null,
  paymentVoucherId: null,
  requestPayments: [],
  requestPayment: {},
  requestPaymentCode: null,
  requestPaymentNavigation: {},

  receiveCheques: [],
  receiveChequeCreateCheck: [],
  receiveCheque: {},
  receiveCashId: null,
  receiveCashVoucherId: null,
  receiveChequeCode: null,
  receiveChequeId: null,
  receiveChequeData: [],
  receiveChequeBackNumber: null,
  receiveChequeBankTransfer: null,
  receiveChequeSampleExcel: null,
  receiveChequeCartable: [],
  receiveChequeVoucher: [],
  receiveChequeNavigation: {},

  transactionInfo: [],

  bankTransfers: [],
  bankTransferIds: [],

  assignmentPersons: [],
  assignmentPersonIds: [],

  settlements: [],

  returnTransferreds: [],

  cancellationReceivables: [],

  returnReceivables: [],
  returnReceivableIds: [],

  returnGuarantees: [],

  returnAssignments: [],
  returnAssignmentIds: [],

  requestPaymentConfirm: [],

  receiveChequeTurns: [],
  receiveChequeTurn: [],

  paymentCheques: [],
  paymentCheque: {},
  paymentChequeCode: null,
  paymentChequeNavigation: {},
  paymentChequeCartable: [],
  paymentChequeSampleExcel: null,
  paymentChequeCheckDelete: "",
  paymentChequeVoucher: [],
  chequeBatchDetailByNumber: [],
  paymentChequeDetailByNumber: [],

  paymentChequeTurns: [],
  paymentChequeTurn: {},

  passPayDocs: [],

  cancelPayableDocs: [],

  returnGuaranteeDocs: [],

  receiptRecevied: [],
  receiptReceviedById: {},
  receiptReceviedMaxCode: null,
  exportReceivedPaper: [],
  receiptReceviedNavigation: {},

  receiveChequeReport: [],
  receiveCashAndCahPaymentReport: [],
  cashAndChequeOperationDetailReport: null,
  monthlyComparisonReceiveAndPaymentCashReport: [],
  historyReceiveChequeReport: [],
  dueReceiveChequeReport: [],
  monthlyComparisonReceiveChequeReport: [],
  summaryReceiveChequeReport: [],

  paymentChequeReport: [],
  historyPaymentChequeReport: [],
  monthlyComparisonPaymentChequeReport: [],
  paymentChequeToPersonReport: [],
  paymentChequeToAccountInfoReport: [],
  paymentChequeTurnReport: [],
  summaryPaymentChequeReport: [],
  overduePaymentChequeReport: [],

  circulationVoucherReport: [],

  cashFlowReport: [],
  cashFlowTableTwoReport: [],

  accountInventoryReport: [],
  summaryPaymentChequeTab: [],
  summaryReceiveChequeTab: [],
  summaryReceiveAndPaymentCash: [],

  receiveAndPayment: [],
  receiveAndPaymentById: {},
  receiveAndPaymentMaxCode: null,

  issueTrackingTypes: [],

  paymentPaper: [],
  paymentPaperById: {},
  paymentPaperMaxCode: null,
  paymentPaperNavigation: {},
  exportPaymentPaper: [],

  paymentChequeManagementCartable: [],
  requestPaymentManagementCartable: [],
  receiveChequeManagementCartable: [],

  cartableLog: [],

  pbankAttachs: [],

  dashboardSixPieCharts: {},
  firstLineChart: [],
  secondLineChart: [],
  thirdLineChart: [],
  fourthLineChart: [],
  fifthLineChart: [],
  sixthLineChart: [],
  printLink: {},

  interBankTransfer: [],
  interBankTransferItem: {},
  interBankTransferNavigation: {},
  bankTransferMaxCode: null,
  interBankTransferId: null,
  interBankTransferVoucher: [],
  bankTransferCheckDelete: "",
  bankTransferVoucherNumber: null,
  bankTransferVoucherId: null,
};
